// extracted by mini-css-extract-plugin
export default {"banner":"HeaderTopInfo_banner__GS9zk","content":"HeaderTopInfo_content__IJm6-","closeButton":"HeaderTopInfo_closeButton__l+dCl","slideDown":"HeaderTopInfo_slideDown__R5ZMe"};